import { TmHomePlanDetail } from './tm-home-plan-detail';
import { getPlans } from '@/lib/data/getHomePlans';
import { ITmHomePlanTemplateCSProps } from './tm-home-plan-detail.types';
import { SizesProvider } from '@/state/sizesProvider';

export const TmHomePlanDetailsCMS = async ({
  block,
}: {
  block: ITmHomePlanTemplateCSProps;
}) => {
  const plans = await getPlans({
    planId: Number(block?.home_plan_id.select),
    studioId: null,
    locationId: null,
  });

  const baseElevation = plans.enrichedPlans.find(
    (plan) => plan.IsBaseElevation,
  );
  return (
    <SizesProvider contentType={block._content_type_uid}>
      <TmHomePlanDetail block={block} baseElevation={baseElevation} />
    </SizesProvider>
  );
};
